import { getInsertStatusLabel } from '../../models/insert';
import { Insert, Mold } from '../../types/mold';
import { GenericColumn } from '../KanbanBoard/utils/tableColumns';
import { MoldListCell } from '../MoldList/TableCell';

export const getColumnsForInsertList = ({ includeMold = false }: { includeMold?: boolean } = {}): Array<GenericColumn<Insert>> => {
    return [
        {
            key: 'id',
            label: 'รหัส',
            sortable: true,
            filterable: true,
            render: (insert: Insert) => insert.id,
            filterOptions: (inserts: Insert[]) => [...new Set(inserts.map(insert => String(insert.id)))],
            getFilterValue: (insert: Insert) => String(insert.id),
            toCSV: (insert: Insert) => String(insert.id),
        },
        {
            key: 'name',
            label: 'ชื่ออินเสิร์ท',
            sortable: true,
            filterable: true,
            render: (insert: Insert) => insert.name,
            filterOptions: (inserts: Insert[]) => [...new Set(inserts.map(insert => insert.name))],
            getFilterValue: (insert: Insert) => insert.name,
            toCSV: (insert: Insert) => insert.name,
        },
        ...(includeMold
            ? [{
                key: 'molds',
                label: 'รหัสแม่พิมพ์',
                sortable: false,
                filterable: false,
                render: (insert: Insert) => (
                    <MoldListCell molds={insert.molds as Mold[]} />
                ),
                toCSV: (insert: Insert) => insert.molds?.map(mold => mold?.sbiId ?? '-').join(', ') || '-',
            }] as GenericColumn<Insert>[]
            : []),
        {
            key: 'status',
            label: 'สถานะ',
            sortable: true,
            filterable: true,
            render: (item: Insert) => {
                const { label, bgColor, textColor } = getInsertStatusLabel(item.status);
                return (<span 
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${bgColor} ${textColor}`}
                >
                    {label}
                </span>)
            },
            filterOptions: (inserts: Insert[]) => [...new Set(inserts.map((item: Insert) => item.status))],
            getFilterValue: (item: Insert) => item.status,
            toCSV: (item: Insert) => item.status,
        },
        {
            key: 'quantity',
            label: 'จำนวน',
            sortable: true,
            filterable: true,
            render: (item: Insert) => (<span>{item.quantity}</span>),
            filterOptions: (inserts: Insert[]) => [...new Set(inserts.map((item: Insert) => item.quantity))],
            getFilterValue: (item: Insert) => item.quantity,
            toCSV: (item: Insert) => item.quantity,
        },
        // {
        //     key: 'createdAt',
        //     label: 'วันที่สร้าง',
        //     sortable: true,
        //     filterable: true,
        //     filterOptions: (items: Insert[]) => [...new Set(items.map(item => formatDateFromString(item.createdAt)))],
        //     getFilterValue: (item: Insert) => formatDateFromString(item.createdAt),
        //     render: (insert: Insert) => formatThaiDate(insert.createdAt),
        //     toCSV: (insert: Insert) => formatThaiDate(insert.createdAt),
        // },
        // {
        //     key: 'updatedAt',
        //     label: 'วันที่แก้ไข',
        //     sortable: true,
        //     filterable: true,
        //     render: (insert: Insert) => formatThaiDate(insert.updatedAt),
        //     toCSV: (insert: Insert) => formatThaiDate(insert.updatedAt),
        // },
    ].filter(Boolean) as Array<GenericColumn<Insert>>; // Ensure the array is properly typed
}